import { useChannels } from "api/channels";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { ChannelForm } from "./ChannelForm";
import { useStyles } from "./ChannelForm.styles";

export function EditChannel() {
  const { message } = useMessage();
  const { id: channelID } = useParams<{ id: string }>();
  const { useChannelsData } = useChannels(channelID);
  const classes = useStyles();
  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "transactionChannels" }),
      path: links.channelList,
    },
  };
  const { data: channelData } = useChannelsData(channelID);

  return (
    <>
      <TopHeader
        breadcrumbs={breadcrumbs}
        clearLink={links.channelList}
        title={message({ id: "editChannel" })}
      />
      <div className={classes.formWrapper}>
        <ChannelForm editMode initialValues={channelData} />
      </div>
    </>
  );
}
